import { InputUG } from "../../components/InputUG";

export const SelectUG = () => {
  return (
    <>
     <InputUG/>
    </>
  );

}